import { css, keyframes } from "styled-components";

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

/* Entrada escalonada: cada item entra um pouco depois do anterior.
   O atraso é limitado para listas longas não demorarem a aparecer.
   `backwards` (e não `both`): o item fica escondido durante o atraso, mas o
   `transform` da animação não fica preso no fim, senão ele anularia o efeito
   de toque do `pressable`. */
export const staggeredFadeInUp = (
  index: number,
  step = 50,
  maxItems = 8,
) => css`
  animation: ${fadeInUp} 0.35s ease-out backwards;
  animation-delay: ${Math.min(index, maxItems) * step}ms;
`;

/* Feedback de toque: no celular não existe hover, então o card "afunda" ao
   ser pressionado. O hover só é aplicado em dispositivos que têm mouse. */
export const pressable = css`
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.2s ease;

  &:active {
    transform: scale(0.98);
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    }
    &:active {
      transform: scale(0.98);
    }
  }
`;
